import type { CityConfig } from "../city-template/types";

export const claytonConfig: CityConfig = {
  city: "Clayton",
  state: "North Carolina",
  stateAbbr: "NC",
  slug: "clayton",
  route: "/cities/clayton",
  title: "Emergency Passport Clayton, NC | Expedited Passport Services | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Clayton, NC — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Johnston County and the southeast Raleigh corridor. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Clayton, NC",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Clayton and Johnston County travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Clayton%20North%20Carolina%20charming%20suburban%20downtown%20at%20golden%20hour%20with%20modern%20growth%20and%20historic%20charm%2C%20tree-lined%20main%20street%20with%20well-maintained%20storefronts%20and%20new%20residential%20developments%2C%20warm%20sunset%20light%20over%20Johnston%20County%2C%20green%20parks%20and%20southern%20community%20atmosphere%2C%20clean%20blue%20sky%20with%20soft%20clouds%2C%20professional%20cityscape%20photography%20with%20warm%20earthy%20tones%20and%20modern%20suburban%20growth%20atmosphere%2C%20no%20text%20or%20signs%20on%20buildings&width=1800&height=700&seq=clayton-hero-nc-001&orientation=landscape",
  heroImageAlt: "Clayton North Carolina charming suburban downtown with tree-lined main street and modern growth at golden hour",
  geoPosition: "35.6507;-78.4564",
  geoPlacename: "Clayton, North Carolina",
  regionalAgency: {
    name: "Atlanta Passport Agency",
    address: "230 Peachtree Street NW, Suite 1400, Atlanta, GA 30303",
    distance: "Located in downtown Atlanta — approximately 380 miles from Clayton via I-85",
  },
  nearbyCitiesZips: [
    { name: "Clayton", zips: "27520, 27527, 27528" },
    { name: "Garner", zips: "27529" },
    { name: "Raleigh", zips: "27601–27699" },
    { name: "Smithfield", zips: "27577" },
    { name: "Wake Forest", zips: "27587, 27588" },
    { name: "Cary", zips: "27511, 27513, 27518, 27519" },
    { name: "Apex", zips: "27502, 27523, 27539" },
    { name: "Holly Springs", zips: "27540" },
    { name: "Fuquay-Varina", zips: "27526" },
    { name: "Knightdale", zips: "27545" },
    { name: "Zebulon", zips: "27597" },
    { name: "Wendell", zips: "27591" },
    { name: "Morrisville", zips: "27560" },
    { name: "Durham", zips: "27701–27717" },
    { name: "Chapel Hill", zips: "27514, 27516, 27517" },
    { name: "Wilson", zips: "27893, 27894, 27895, 27896" },
    { name: "Rocky Mount", zips: "27801, 27802, 27803, 27804" },
    { name: "Goldsboro", zips: "27530, 27531, 27533, 27534" },
    { name: "Fayetteville", zips: "28301–28312" },
    { name: "Selma", zips: "27576" },
    { name: "Benson", zips: "27504" },
    { name: "Four Oaks", zips: "27524" },
    { name: "Angier", zips: "27501" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Johnston County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Johnston County Hub", desc: "Serving Clayton, Smithfield, and the southeast Raleigh corridor" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Raleigh, NC", route: "/cities/raleigh" },
    { name: "Fast passport renewal in Garner, NC", route: "/cities/garner" },
    { name: "Emergency passport help in Cary, NC", route: "/cities/cary" },
    { name: "Urgent passport services in Wake Forest, NC", route: "/cities/wake-forest" },
    { name: "Same-day passport help in Morrisville, NC", route: "/cities/morrisville" },
    { name: "Passport courier services in Apex, NC", route: "/cities/apex" },
    { name: "Passport courier services in Holly Springs, NC", route: "/cities/holly-springs" },
    { name: "Passport courier services in Fuquay-Varina, NC", route: "/cities/fuquay-varina" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Clayton remotely via secure courier. We do not have a walk-in office in Clayton — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Johnston County and the southeast Raleigh corridor travelers.",
  fpcOfficeDistance: "Serving all of Johnston County and the southeast Raleigh corridor",
  serviceAreaIntro: "From the growing downtown of Clayton to the quiet communities of Smithfield and Selma, from the Raleigh city line to the Johnston County countryside, from Knightdale to Zebulon, from Wendell to Wake Forest, from Cary to Apex, from Holly Springs to Fuquay-Varina, from Morrisville to Durham, from Wilson to Rocky Mount, from Goldsboro to Fayetteville — Fast Passport Center serves the entire Clayton region. We regularly help travelers from Johnston County, southeast Wake County, and eastern North Carolina get their passports fast.",
  nearbyCitiesIntro: "We serve all Clayton neighborhoods and the surrounding Johnston County and southeast Raleigh area including Garner, Raleigh, Smithfield, Wake Forest, Cary, Apex, Holly Springs, Fuquay-Varina, Knightdale, Zebulon, Wendell, Morrisville, Durham, Chapel Hill, Wilson, Rocky Mount, Goldsboro, Fayetteville, Selma, Benson, Four Oaks, and Angier. If you are anywhere in Johnston County, Wake County, or the southeast Raleigh corridor, we have you covered.",
  howItWorksIntro: "Most Clayton travelers complete everything online and ship documents overnight. No need to drive to Atlanta or wait in line at the regional agency.",
  mistakesIntro: "Clayton travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Clayton and Johnston County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Clayton? Here are the most common ones we hear from Johnston County travelers.",
  statePageRoute: "/states/north-carolina",
  statePageName: "North Carolina",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Clayton international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Amanda P.",
      location: "Clayton, NC",
      rating: 5,
      text: "My passport expired 3 days before our cruise to the Bahamas. Fast Passport Center had my renewal in 28 hours. I never left Clayton. Their Johnston County service is incredible.",
      service: "Passport Renewal",
    },
    {
      name: "Brian T.",
      location: "Smithfield, NC",
      rating: 5,
      text: "Emergency passport for a family emergency in Germany. Got it in 27 hours. Fast Passport Center handled everything — I didn't have to drive to Atlanta. Truly a lifesaver.",
      service: "Emergency Passport",
    },
    {
      name: "Nicole H.",
      location: "Garner, NC",
      rating: 5,
      text: "First passport for my 9-year-old before our Disney cruise. Fast Passport Center walked us through every document. Had her passport in 5 days. So easy for Johnston County families.",
      service: "Child Passport",
    },
    {
      name: "Mark R.",
      location: "Raleigh, NC",
      rating: 5,
      text: "Lost my passport 2 days before a business trip to London. Fast Passport Center had a replacement in 29 hours. Their southeast Wake coverage is the best I've found.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "clayton-1",
      name: "Clayton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "215 E 2nd St",
      city: "Clayton",
      state: "NC",
      zip: "27520",
      phone: "(919) 553-4501",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Clayton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Clayton facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "clayton-2",
      name: "Garner Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1300 Timber Dr",
      city: "Garner",
      state: "NC",
      zip: "27529",
      phone: "(919) 779-4501",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "10 miles northwest of Clayton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves southeast Wake County and Garner area. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "clayton-3",
      name: "Raleigh Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "414 E Holding Ave",
      city: "Raleigh",
      state: "NC",
      zip: "27610",
      phone: "(919) 755-4501",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "15 miles north of Clayton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major regional facility for Raleigh metro. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "clayton-4",
      name: "Smithfield Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "225 E Market St",
      city: "Smithfield",
      state: "NC",
      zip: "27577",
      phone: "(919) 934-4501",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "12 miles southeast of Clayton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Johnston County seat. Alternative for Clayton and Johnston County residents.",
      icon: "ri-mail-line",
    },
    {
      id: "clayton-5",
      name: "Wake County Clerk of Court",
      type: "Court Clerk Passport Acceptance",
      address: "300 S Salisbury St",
      city: "Raleigh",
      state: "NC",
      zip: "27601",
      phone: "(919) 792-4000",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "15 miles north of Clayton, Courthouse",
      website: "https://www.wakegov.com/",
      websiteLabel: "Wake County Clerk",
      notes: "Accepts passport applications. Good alternative to post office with extended hours. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "clayton-6",
      name: "Cary Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "315 N Academy St",
      city: "Cary",
      state: "NC",
      zip: "27513",
      phone: "(919) 467-4501",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "20 miles west of Clayton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Full-service facility for Cary and Morrisville residents. Photo services nearby.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 5.5 hour drive to Atlanta", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Clayton photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Johnston County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Clayton applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Johnston County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Clayton travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Clayton." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Clayton address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Clayton before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Clayton for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 5.5 hour drive to Atlanta." },
    { q: "How fast can I renew my passport in Clayton?", a: "Fast Passport Center offers fast passport renewal in Clayton in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Clayton?", a: "The nearest regional passport agency to Clayton is the Atlanta Passport Agency, approximately 380 miles away via I-85. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Clayton without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Clayton?", a: "Same-day passport appointments are only available at the Atlanta Regional Passport Agency — approximately 5.5 hours from Clayton — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Johnston County and southeast Wake County residents." },
    { q: "Do you serve the entire Johnston County area?", a: "Absolutely. Fast Passport Center serves the entire Johnston County and southeast Wake County area including Clayton, Garner, Raleigh, Smithfield, Wake Forest, Cary, Apex, Holly Springs, Fuquay-Varina, Knightdale, Zebulon, Wendell, Morrisville, Durham, Wilson, Rocky Mount, Goldsboro, Fayetteville, Selma, Benson, Four Oaks, and Angier. Our courier service works seamlessly from any address in the region." },
    { q: "Can I expedite a child passport in Clayton?", a: "Yes. Fast Passport Center expedites child passports in Clayton for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Johnston County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Clayton with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Atlanta Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Clayton", address: "215 E 2nd St, Clayton, NC 27520", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Clayton", address: "11400 US-70 BUS, Clayton, NC 27520", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Supercenter — Clayton", address: "14065 US-70, Clayton, NC 27520", hours: "Mon–Sun: 6AM–11PM" },
    { name: "CVS Pharmacy — Garner", address: "1405 Timber Dr, Garner, NC 27529", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Smithfield", address: "1299 N Brightleaf Blvd, Smithfield, NC 27577", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Raleigh", address: "3600 New Bern Ave, Raleigh, NC 27610", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Cary", address: "1140 Kildaire Farm Rd, Cary, NC 27511", hours: "Mon–Sun: 7AM–11PM" },
    { name: "FedEx Office — Raleigh", address: "435 S Salisbury St, Raleigh, NC 27601", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    {
      name: "NC DMV — Clayton",
      address: "50 Tramway Cir, Clayton, NC 27520",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "NC DMV — Garner",
      address: "4031 Jones Sausage Rd, Garner, NC 27529",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves southeast Wake County and Garner area. REAL ID available.",
      featured: true,
    },
    {
      name: "NC DMV — Raleigh",
      address: "3231 Avent Ferry Rd, Raleigh, NC 27606",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Raleigh and western Wake County. REAL ID available.",
      featured: false,
    },
    {
      name: "NC DMV — Smithfield",
      address: "215 E Main St, Smithfield, NC 27577",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Johnston County seat. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "RDU",
      name: "Raleigh-Durham International Airport",
      distance: "25 miles northwest of Clayton",
      address: "2400 John Brantley Blvd, Morrisville, NC 27560",
      note: "Major international airport for the Research Triangle. Direct flights to London, Paris, Cancun, Toronto, and major domestic destinations. American, Delta, and United hub. Only 30 minutes from Clayton.",
      flightUrl: "https://www.rdu.com/",
      flightLabel: "RDU Airport",
      featured: true,
    },
    {
      code: "CLT",
      name: "Charlotte Douglas International Airport",
      distance: "160 miles southwest of Clayton",
      address: "5501 Josh Birmingham Pkwy, Charlotte, NC 28208",
      note: "Major alternative hub for the Charlotte metro area. Additional international routes.",
      flightUrl: "https://www.cltairport.com/",
      flightLabel: "CLT Airport",
      featured: false,
    },
    {
      code: "GSO",
      name: "Piedmont Triad International Airport",
      distance: "80 miles west of Clayton",
      address: "1000 Ted Johnson Pkwy, Greensboro, NC 27409",
      note: "Alternative airport for North Carolina residents. Additional domestic routes.",
      flightUrl: "https://www.flyfrompti.com/",
      flightLabel: "GSO Airport",
      featured: false,
    },
  ],
};